import { render, staticRenderFns } from "./healthandsafetypage.vue?vue&type=template&id=01fbce88"
import script from "./healthandsafetypage.vue?vue&type=script&lang=js"
export * from "./healthandsafetypage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports